import { CargoType } from '@planning/app/api'
import { FieldStore, FormStore, required, validateSubForm } from '@tom-ui/utils'
import { action, makeObservable } from 'mobx'

export type RailVisitCargoFormStoreType = {
  cargoType: CargoType | null
  dischargeEstimate: number
  loadEstimate: number
}

export class RailVisitCargoFormStore extends FormStore<RailVisitCargoFormStoreType> {
  cargoType: FieldStore<CargoType | null>
  dischargeEstimate: FieldStore<number | undefined>
  loadEstimate: FieldStore<number | undefined>

  constructor(initialValues?: Partial<RailVisitCargoFormStoreType>) {
    super(initialValues)

    makeObservable(this, {
      setData: action,
      patchData: action,
      reset: action,
    })

    this.cargoType = new FieldStore(initialValues?.cargoType ?? null, required())
    this.dischargeEstimate = new FieldStore<number | undefined>(initialValues?.dischargeEstimate)
    this.loadEstimate = new FieldStore<number | undefined>(initialValues?.loadEstimate)
  }

  setData(data: Partial<RailVisitCargoFormStoreType>) {
    this.cargoType.setValue(data.cargoType ?? CargoType.Container)
    this.dischargeEstimate.setValue(data.dischargeEstimate ?? 0)
    this.loadEstimate.setValue(data.loadEstimate ?? 0)
  }

  patchData(data: Partial<RailVisitCargoFormStoreType>) {
    if (data.cargoType) {
      this.cargoType.setValue(data.cargoType)
    }

    if (data.dischargeEstimate) {
      this.dischargeEstimate.setValue(data.dischargeEstimate)
    }

    if (data.loadEstimate) {
      this.loadEstimate.setValue(data.loadEstimate)
    }
  }

  reset() {
    this.setData(this.initialValues)
  }

  validate = () => {
    return validateSubForm(this)
  }

  get data(): RailVisitCargoFormStoreType {
    return {
      cargoType: this.cargoType.value,
      dischargeEstimate: this.dischargeEstimate.value ?? 0,
      loadEstimate: this.loadEstimate.value ?? 0,
    }
  }

  get isDirty(): boolean {
    return this.cargoType.dirty || this.dischargeEstimate.dirty || this.loadEstimate.dirty
  }
}
